import { useTranslation } from "react-i18next"

import { CircleX, MessageSquareQuote } from "@/components/icons"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"

type ChatFooterAskAboutPillProps = {
  text: string
  onRemove: () => void
}

const iconButtonStyles =
  "flex size-6 cursor-pointer items-center justify-center rounded-full bg-card text-card-foreground ring-1 ring-border shadow-sm transition-[color,background-color,box-shadow,scale] duration-150 hover:scale-110 hover:bg-accent hover:text-accent-foreground hover:shadow-md active:scale-95"

export function ChatFooterAskAboutPill({ text, onRemove }: ChatFooterAskAboutPillProps) {
  const { t } = useTranslation()

  return (
    <section className="group bg-card hover:bg-accent/50 relative shrink-0 rounded-lg border px-3 py-2 transition-colors">
      <div className="flex items-center gap-2.5">
        <div className="flex-shrink-0">
          <MessageSquareQuote className="text-muted-foreground size-4" />
        </div>
        <div className="max-w-[200px] min-w-0">
          <div className="text-foreground truncate text-xs font-medium">{text}</div>
        </div>
      </div>
      <div className="absolute -top-2.5 -right-1.5 flex items-center gap-1 opacity-100 transition-opacity lg:opacity-0 lg:group-hover:opacity-100">
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              className={`${iconButtonStyles} hover:bg-destructive/10 hover:text-destructive`}
              type="button"
              onMouseDown={(event) => {
                event.preventDefault()
                onRemove()
              }}
            >
              <CircleX className="size-3.5" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{t("questioninput.remove_ask_about")}</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </section>
  )
}
